import { render, staticRenderFns } from "./LeadCenterOverview.vue?vue&type=template&id=088a5e23&"
import script from "./LeadCenterOverview.vue?vue&type=script&lang=js&"
export * from "./LeadCenterOverview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports